import { CubeIconSmall } from "../Shared/Components/SvgIcons"
import Image from "../Shared/Primitive/Image"
import { formatDate } from "../../App/Helpers/Helpers"

function UpcomingEventsDropdownItem(props: {
    id: number
    sender?: string
    action_url?: string
    redirect_url?: string
    name?: string
    notification?: string
    date: string
    isRead?: boolean
    post?: number
    onClick?: () => void
    isLastItem: boolean
    roomId: number
    roomName: string
    invitation_id?: number
    isDropDown?: boolean
    location: string
    format: string
    image?: string
    isSoon?: boolean
    onRoomClick?: () => void
}) {
    // Keep event rendering consistent with room event modal formatting.
    const userOffset = new Date().getTimezoneOffset() * 60 * 1000
    const startDate = new Date(new Date(props.date).getTime() - userOffset)
    const dateLabel = formatDate(props.date, "EEE, dd MMM")
    const timeLabel = formatDate(props.date, "HH:mm")

    const getRelativeDateLabel = () => {
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        const eventDay = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate())
        const dayDiff = Math.round((eventDay.getTime() - today.getTime()) / (1000 * 60 * 60 * 24))

        if (dayDiff === 0) {
            return "Heute"
        }

        if (dayDiff === 1) {
            return "Morgen"
        }

        if (dayDiff > 1) {
            return `In ${dayDiff} Tagen`
        }

        return "Läuft bereits"
    }

    const normalizedLocation = (props.location || "").replaceAll("_", " ")
    const normalizedFormat = (props.format || "").replaceAll("_", " ")

    return (
        <div
            className={`notification-dropdown-item notification-dropdown-item--event notification-dropdown-item--${props.isLastItem && "border-none"} notification-dropdown-item--${props.isRead === false && "color-grey"
                }`}
            onClick={props.onClick}
        >
            <div className="notification-dropdown-item__content">
                <div className="notification-dropdown-item__left-panel-no-padding">
                    <div className="room-events__item-date-small">
                        <div className='room-events__item-date-day'>
                            {formatDate(props.date, "d")}
                        </div>
                        <div className='room-events__item-date-month'>
                            {formatDate(props.date, "MMM")}
                        </div>
                    </div>
                </div>
                {!props.isDropDown && (
                    <div className="notification-dropdown-item__image-panel">
                        <div className="room-events__dropdown-image-container">
                        {props?.image ? (<Image src={props.image} className="room-events__dropdown-image" />) : (
                            <Image src="/event_default.png" className="room-events__dropdown-image" />
                        )}
                    </div>
                    </div>
                )}
                <div className={`notification-dropdown-item__middle-panel`}>
                    <div className="notification-dropdown-item__event-heading">
                        <div className={`notification-dropdown-item__event-name`}>
                            {props.name}
                        </div>
                        {props.isSoon && <div className="notification-dropdown-item__event-badge">Bald</div>}
                    </div>

                    <div
                        className={`notification-dropdown-item__notification notification-dropdown-item__notification--margin-bottom`}
                    >
                        <div className="notification-dropdown-item__event-date-line">
                            <span>{dateLabel}</span>
                            <span>•</span>
                            <span>{timeLabel}</span>
                            <span>•</span>
                            <span>{getRelativeDateLabel()}</span>
                        </div>

                        <div className="notification-dropdown-item__event-chips">
                            {normalizedLocation && (
                                <span className="notification-dropdown-item__event-chip">{normalizedLocation}</span>
                            )}
                            {normalizedFormat && (
                                <span className="notification-dropdown-item__event-chip">{normalizedFormat}</span>
                            )}
                        </div>

                        <div className="notification-dropdown-item__event-room-row">
                            <div className="notification-dropdown-item__event-room-name">
                                <CubeIconSmall />
                                <span>{props.roomName}</span>
                            </div>
                            {props.onRoomClick && (
                                <button
                                    type="button"
                                    className="notification-dropdown-item__room-link"
                                    onClick={(event) => {
                                        event.stopPropagation()
                                        props.onRoomClick?.()
                                    }}
                                >
                                    Zum Raum
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            
        </div>
    )
}

export default UpcomingEventsDropdownItem
